var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNumber = function SvgNumber(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_8759)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.562988,
    width: 10.7646,
    height: 10.8673,
    rx: 2.5,
    fill: "#2E3744",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2871 4.25133H8.34246L8.61928 3.12044C8.66772 2.93196 8.85457 2.82027 9.04142 2.86913C9.22135 2.918 9.339 3.10648 9.29056 3.28798L9.05526 4.25133H9.65042C9.84419 4.25133 9.99644 4.40491 9.99644 4.60037C9.99644 4.79584 9.84419 4.94941 9.65042 4.94941H8.88225L8.36322 7.04365H9.65042C9.84419 7.04365 9.99644 7.19723 9.99644 7.39269C9.99644 7.58816 9.84419 7.74173 9.65042 7.74173H8.19021L7.91339 8.87262C7.86495 9.06111 7.6781 9.1728 7.49817 9.13091C7.31132 9.08205 7.20059 8.89357 7.24211 8.71207L7.47741 7.74872H5.42205L5.14523 8.87961C5.09679 9.06809 4.90993 9.17978 4.73 9.13789C4.54315 9.08903 4.43243 8.90055 4.47395 8.71905L4.70924 7.7557H4.11409C3.92032 7.7557 3.76807 7.60212 3.76807 7.40666C3.76807 7.21119 3.92032 7.05762 4.11409 7.05762H4.88225L5.40128 4.96338H4.11409C3.92032 4.96338 3.76807 4.8098 3.76807 4.61434C3.76807 4.41887 3.92032 4.2653 4.11409 4.2653H5.5743L5.85111 3.1344C5.89955 2.94592 6.08641 2.83423 6.27326 2.8831C6.45319 2.93196 6.57083 3.12044 6.52239 3.30194L6.2871 4.2653V4.25133ZM6.11409 4.94941L5.59506 7.04365H7.65042L8.16945 4.94941H6.11409Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_8759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.882324)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNumber);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "number.e331f23b1e981e5a7d18d0d1ac4dc900.svg";